import { render, staticRenderFns } from "./sectHeader.vue?vue&type=template&id=daaf3022"
import script from "./sectHeader.vue?vue&type=script&lang=js"
export * from "./sectHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports